//frontend/src/components/InfoManage/PopList.js

import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../config";
import "./PopList.css";

const PopList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [pops, setPops] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [expandedPopId, setExpandedPopId] = useState(null);

  useEffect(() => {
    fetchPops();
  }, []);

  const fetchPops = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/info-manage/pops`);
      const json = await res.json();
      if (json.success) {
        setPops(json.data);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (popId) => {
    if (!window.confirm("Are you sure you want to delete this POP?")) return;
    try {
      const res = await fetch(`${API_BASE_URL}/info-manage/pops/delete/${popId}`, {
        method: "DELETE"
      });
      const result = await res.json();
      if (result.success) {
        fetchPops();
      } else {
        alert(result.error || "Delete failed");
      }
    } catch (err) {
      alert("Error connecting to server");
    }
  };

  const toggleDetails = (id) => {
    setExpandedPopId(prevId => (prevId === id ? null : id));
  };

  const filteredPops = pops.filter(pop =>
    pop.pop_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    pop.id?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="pop-container">
      <div className="pop-header-card">
        <h2 className="pop-title">{t("pop_list")}</h2>
        <div style={{ display: "flex", gap: "10px", justifyContent: "auto" }}>
          <input
            type="text"
            placeholder="Search ID or Name..."
            className="pop-search-input"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="pop-btn login" onClick={() => navigate("/info-manage/add-pop")}>
            + {t("add_new")}
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", color: "#94a3b8", marginTop: "20px" }}>Loading...</div>
      ) : (
        <ul className="pop-list" style={{ marginTop: "20px" }}>
          {filteredPops.map((pop) => {
            const isExpanded = expandedPopId === pop.id;
            return (
              <li key={pop.id} className="pop-item">
                <div className="pop-item-main">
                  <div className="pop-info">
                    <div className={`dl-status-dot ${pop.pop_type?.toLowerCase()}`}></div>
                    <div className="pop-meta">
                      <strong className="pop-hostname">{pop.pop_name}</strong>
                      <div style={{ fontSize: "0.8rem", color: "#94a3b8" }}>
                        ID: {pop.id} | {pop.pop_type}
                        {pop.parent_pop_name && ` | Parent: ${pop.parent_pop_name}`}
                      </div>
                    </div>
                  </div>
                  <div className="pop-actions">
                    <button className="pop-btn info" onClick={() => toggleDetails(pop.id)}>
                      {isExpanded ? t("hide") : t("details")}
                    </button>
                    <button className="pop-btn edit" onClick={() => navigate(`/info-manage/edit-pop/${pop.id}`)}>
                      {t("edit")}
                    </button>
                    <button className="pop-btn delete" onClick={() => handleDelete(pop.id)}>
                      {t("delete")}
                    </button>
                  </div>
                </div>

                {isExpanded && (
                  <div className="pop-details-box">
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                      <p><strong>Contact:</strong> {pop.contact_person || "-"}</p>
                      <p><strong>Mobile:</strong> {pop.mobile || "-"}</p>
                      <p><strong>Email:</strong> {pop.email || "-"}</p>
                      <p><strong>Address:</strong> {pop.address || "-"}</p>
                      <p><strong>Parent POP:</strong> {pop.parent_pop_name || "-"}</p>
                      <p><strong>Notes:</strong> {pop.notes || "-"}</p>
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default PopList;